import { render, staticRenderFns } from "./QQButton.vue?vue&type=template&id=7403cf33&scoped=true&"
import script from "./QQButton.vue?vue&type=script&lang=js&"
export * from "./QQButton.vue?vue&type=script&lang=js&"
import style0 from "./QQButton.vue?vue&type=style&index=0&id=7403cf33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7403cf33",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QList,QItem,QItemSection,QAvatar,QItemLabel});
